import { Injectable } from '@angular/core';
import { CsaAuthService } from '../auth/csa-auth.service';
import { FeatureAccessService } from '../common-services/feature-access.service';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  constructor(private auth: CsaAuthService, private featureAccessService: FeatureAccessService) { }

  /**
   * Above store level dashboard panels need a query param attached to their API requests which captures the details of their user
   * this function gets the user and builds the query params.
   *
   * @param addGPSFilter - If true, the function will check if the user needs to attach 'filterName=eitb'
   * (which restricts results to only eitb assessments or actions- aka GPS) - based on if they have access to ONLY GPS assessments via features.
   * @returns Filter with query params.
   */
  getQueryParamsBasedOnUserLevel(addGPSFilter: boolean): string {
    const user = this.auth.user;
    let filter = '';

    if (user.state) {
      filter += `&state=${user.state}`;
    }
    if (user.zone) {
      filter += `&zone=${user.zone}`;
    }
    if (user.region) {
      filter += `&region=${user.region}`;
    }
    if (user.area) {
      filter += `&area=${user.area}`;
    }
    if (user.groupNo) {
      filter += `&groupID=${user.groupNo}`;
    }

    if (addGPSFilter && (this.featureAccessService.hasAccess('adhocAssessments.viewAssignedGPSOnly') || this.featureAccessService.hasAccess('adhocAssessments.viewOthersAssessmentsGPSOnly') || this.featureAccessService.hasAccess('adhocAssessments.viewAssignedClosedAssessmentsGPSOnly'))) {
      filter += '&filterName=eitb';
    }

    return filter;
  }
}
